import {
  GET_TYPE_CONFIGURATION_EXITO,
  GET_TYPE_CONFIGURATION
} from '../types/typeConfigurationtActionsTypes'
import { TypeConfiguration } from '../../interfaces/Configuration/Configuration'

export type TypeConfigurationAction =
  | TypeConfigurationsAction
  | TypeConfigurationsActionAsync

// Esto va a REDUX
export interface TypeConfigurationsAction {
  type: typeof GET_TYPE_CONFIGURATION_EXITO
  typeConfiguration: TypeConfiguration[]
  error: string | undefined
}

export const getTypeConfigurationAction = (
  typeConfiguration: TypeConfiguration[],
  error?: string
): TypeConfigurationsAction => {
  return {
    type: GET_TYPE_CONFIGURATION_EXITO,
    typeConfiguration: typeConfiguration,
    error
  }
}

// Esto va a SAGA
export interface TypeConfigurationsActionAsync {
  type: typeof GET_TYPE_CONFIGURATION
}

export const getTypeConfigurationActionAsync =
  (): TypeConfigurationsActionAsync => {
    return {
      type: GET_TYPE_CONFIGURATION
    }
  }
